import { FunctionComponent, useState, useRef, useEffect } from "react";
import CalIcon from "../../assets/task/calendar-icon.svg";
import userCricleimg from "../../assets/task/user-circle_svgrepo.com.svg";
import taskIcons from "../../assets/task/task-square_svgrepo.com.svg";
import userICon from "../../assets/task/uses-icon.svg";
import CalIconcheck from "../../assets/task/task_svgrepo.com.svg";
import { format } from "date-fns";
import triPledots from '../../assets/task/triple_dot.svg';
import { useNavigate } from "react-router-dom";

interface InProgressTasksProps {
    g: any;
}

const InProgressTasks: FunctionComponent<InProgressTasksProps> = ({
    g,
}) => {
    const navigate = useNavigate()
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLImageElement>(null); // Ref for the triple dot button

    const toggleMenu = (e: React.MouseEvent) => {
        e.stopPropagation(); // Prevent the goal click from being triggered
        setShowMenu(prev => !prev);
    };

    const createdOnDate = g?.created_on
        ? format(g?.created_on, 'MMM dd, yyyy') : "";

    const dueDate = g?.end_datetime
        ? format(g?.end_datetime, 'MMM dd, yyyy') : ""

    // Close the menu if clicked outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            // Check if the click is outside the menu AND not on the toggle button
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target as Node) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target as Node)
            ) {
                setShowMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // const handleArchive = (e: React.MouseEvent) => {
    //     e.stopPropagation();
    //     console.log(`Archive Goal: ${g?.id}`);
    //     setShowMenu(false);
    // };

    return (
        <div
            className="self-stretch flex flex-col items-start justify-start p-4 gap-4 text-base cursor-pointer" // Add cursor-pointer for better UX
            onClick={() => {
                navigate("/task_detail", {
                    state: {
                        taskId: g?.id,
                    }
                })
            }}
        >
            <div className="self-stretch shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] rounded bg-white border-whitesmoke border-solid border-[1px] box-border flex flex-col items-start justify-start p-2 gap-2">
                <div className="self-stretch rounded bg-antiquewhite border-orange border-solid border-[1px] flex flex-row items-start justify-between p-2 gap-2.5 text-lg relative"> {/* Added relative here for positioning the menu */}
                    <b className="flex-1 relative">{g?.title}</b>
                </div>
                <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                    {/* <div className="flex flex-row items-center justify-center gap-1.5">
                        <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIcon} />
                        <div className="relative">Outcome</div>
                    </div> */}
                    <div className="flex flex-row items-center justify-center text-dimgray">
                        <b className="relative whitespace-pre-wrap">{g?.static_task_type_name}</b>
                    </div>
                </div>
                <hr className="bdr-custom-taskcrad" />
                <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                    <div className="flex flex-row items-center justify-center gap-1.5">
                        <img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src={CalIcon} />
                        <div className="relative">Created Date</div>
                    </div>
                    <div className="flex flex-row items-center justify-center text-dimgray">
                        <div className="relative whitespace-pre-wrap">{createdOnDate}</div>
                    </div>
                </div>
                <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                    <div className="flex flex-row items-center justify-center gap-1.5">
                        <img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src={CalIconcheck} />
                        <div className="relative">Due Date</div>
                    </div>
                    <div className="flex flex-row items-center justify-center text-dimgray">
                        <div className="relative whitespace-pre-wrap">{dueDate}</div>
                    </div>
                </div>
                <hr className="bdr-custom-taskcrad" />
                <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                    <div className="flex flex-row items-center justify-center gap-1.5">
                        <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userICon} />
                        <div className="relative">Assignee</div>
                    </div>
                    <div className="flex flex-row items-center justify-center text-dimgray">
                        <div className="relative">{g?.assigned_to_name}</div>
                    </div>
                </div>
                <div className="self-stretch flex flex-row items-center justify-start py-0 px-2 gap-2 text-lightseagreen">
                    {g?.task_tags?.length > 0 && (
                        g?.task_tags?.map((gt: any) => {
                            return (
                                <div className="relative" key={gt.id}>
                                    <span className="text-dimgray"> {gt?.tags_name}</span>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    )
}

export default InProgressTasks;